import {atom} from 'recoil';

const loadingState = atom({
  key: 'customers_table_loading',
  default: true
})

const errorState = atom({
  key: 'customers_table_error',
  default: false
})

const rowsState = atom({
  key: 'customers_table_rows',
  default: []
})

const deleteModalOpenState = atom({
  key: 'customers_table_delete_modal_open',
  default: false,
});

const deleteModalCodeState = atom({
  key: 'customers_table_delete_modal_code',
  default: '',
});

const firstRowIndexState = atom({
  key: 'customers_table_first_row_index',
  default: 0
})

const pageSizeState = atom({
  key: 'customers_table_page_size',
  default: 25
})

export {
  loadingState,
  errorState,
  rowsState,
  deleteModalOpenState,
  deleteModalCodeState,
  firstRowIndexState,
  pageSizeState
}